/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { ERROR_TEXTS, FORM_ERRORS_KEYS, FORM_KEYS, INITIAL_ERRORS, INITIAL_FORM } from "../constants";
import { getMinutesOfToday } from "components/CustomTimePicker/utils";
import { getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
import { isScheduleField } from "../helpers";

const useAdminReservationForm = ({
	filterDate
}) => {
	//#region States
	const [form, setForm] = useState({ ...INITIAL_FORM });
    const [errors, setErrors] = useState({ ...INITIAL_ERRORS });
    //#endregion
	//#region Effects
	useEffect(() => {
		setDate(filterDate);
	}, []);
	//#endregion
    //#region Functions
	function setField(field, value) {
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
        if (isScheduleField(field)) 
            setScheduleError(null);
    }
	function setError(field, value) {
        setErrors(prev => ({
            ...prev,
            [field]: value
        }));
    }
	function setName(value) {
        setField(FORM_KEYS.NAME, value);
    }
    function setDetails(value) {
        setField(FORM_KEYS.DETAILS, value);
    }
	function setDate(value) {
        setField(FORM_KEYS.DATE, value);
    }
    function setTimeStart(value) {
        setField(FORM_KEYS.TIME_START, value);
    }
    function setTimeEnd(value) {
        setField(FORM_KEYS.TIME_END, value);
    }
    function setScheduleError(value) {
        setError(FORM_ERRORS_KEYS.SCHEDULE, value);
    }
	function checkScheduleError() {
        const { date, timeStart, timeEnd } = form;
        if (timeStart >= timeEnd) 
            return ERROR_TEXTS.START_DATE_IS_GREATER_THAN_END_DATE;
        const now = getMinutesOfToday();
        const today = getTodayWithoutHourInMillis();
        if (date < today || (date === today && timeStart < now)) 
			return ERROR_TEXTS.PAST_SCHEDULE;
		return null;
    }
    function hasErrors(errorList) {
		return errorList.some(error => error);
    }
	function validate() {
		const scheduleError = checkScheduleError();
		if (scheduleError) 
			setError(FORM_ERRORS_KEYS.SCHEDULE, scheduleError);
		return !hasErrors([scheduleError]);
	}
    function areCompleted() {
        const { name, details, timeStart, timeEnd } = form;
        return name && details && timeStart > -1 && timeEnd > -1;
    }
	//#endregion
	return {
		form: {
            value: form,
            setName, setDetails,
            setTimeStart, setTimeEnd,
    		validate, areCompleted
        },
		errors: {
            value: errors,
            setSchedule: setScheduleError
        }
	};
}
	
export default useAdminReservationForm;